module.exports = __webpack_public_path__ + "static/img/concierge_back_bodyfriend.cc4e864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/concierge_back_bodyfriend.png
// module id = 3x6W
// module chunks = 1